<template lang="pug">
.caseDialogue(v-disabled="seeState")
  .Dialogue-box
    Form(:model="question")
      FormItem(label="部门文件" :label-width="80")
        iDelModel.del(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')" :isDep="isEdit" @handleDel='handleDel')
      div
        div(v-for="(app,index) in question.DeptData" :key="app.key")
          FormItem(:label="`#部门${index + 1}`" :label-width="80")
            Row(:gutter="16")
              Col(span="16")
                //- deptData
                Select(v-model="app.deptId")
                  Option(v-for="val in deptData" :key="val.id" :value="val.id") {{ val.departmentName }}
              Col(span="4")
                Button(v-if="index != 0" type="error" shape="circle" icon="md-close" size="small" @click="handleDelParent(index)")
          FormItem(label="" :label-width="80")
            Button(type="primary" ghost @click="handleAddParent") + 添加部门
            Row(v-for="(val,i) in app.childList" :key="val.key" :gutter="16" style="margin-top:10px;")
              FormItem(:label="`#文件${i + 1}`" :label-width="80")
                Col(span="16")
                  Input(type='text',placeholder='请输入文件' v-model="val.title" :maxlength="10")
                Col(span="4")
                  Button(v-if="i != 0" type="error" shape="circle" icon="md-close" size="small" @click="handleDelChild(index,i)")
              FormItem(label=" " :label-width="80")
                Col(span="20")
                  div(style="padding:0 8px;margin-top:20px")
                    quillEditor(ref="myQuillEditor2" :options="editorOption" v-model="val.descr")
                  div(style="padding:0 8px;margin-top:20px;")
                    Upload(ref="upload",:before-upload="(file)=>handleUpload(file,index,i)",multiple,:show-upload-list="true",:on-remove="(file,fileList)=>handleRemoveFile(fileList,index,i)"
                            :max-size="10240"
                            :default-file-list="val.urlList"
                            action=" " style="display:block;")
                            Button.button + 上传文件
                            p.uploadDesc 文件格式支持pdf、doc、docx、xls、xlsx、ppt、pptx，文件大小限制10M。
              FormItem(label=" " :label-width="80")
                Col(span="16")
                  div(style="padding:0 8px;margin-top:20px")
                    Button(type="primary" ghost @click="handleAddChild(index)") + 添加文件
            //- Button(type="error" shape="circle" icon="md-close" size="small")
      //-     Button.button(@click='addMeta2',
      //- style='color:#3A76D2;border: 1px solid #3A76D2;text-align:left;margin-left: 0px;') + 添加分析师讲话
</template>

<script>
import iDelModel from "@/components/common/iDelModel";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    iDelModel,
    quillEditor
  },
  props: ["data"],
  inject: ["seeState"],

  data() {
    return {
      editorOption: {
        placeholder: "请输入文件内容",
        modules: {
          toolbar: [
            [
              "bold",
              "italic",
              "underline",
              "strike",
              "image",
              "link",
              { indent: "-1" },
              { indent: "+1" },
              { align: "" },
              { align: "center" },
              { align: "right" },
              { color: [] },
              { background: [] },
              {
                font: [
                  "SimSun",
                  "SimHei",
                  "Microsoft-YaHei",
                  "KaiTi",
                  "FangSong",
                  "Arial",
                  "sans-serif"
                ]
              },
              { size: ["small", false, "large", "huge"] }
            ]
          ]
        }
      },
      deptData: [],
      question: {
        DeptData: [
          {
            deptId: "",
            childList: [
              {
                urlList: [],
                key: "o",
                title: "",
                descr: "",
                bizCode: "BMWJ"
              }
            ]
          }
        ]
      }
    };
  },
  computed: {
    parentCase() {
      return this.$parent.case;
    },
    taskInfo() {
      return JSON.parse(sessionStorage.getItem("taskInfo"));
    },
    isEdit() {
      return this.question?.DeptData?.some((v) => v.deptId !== "");
    }
  },
  methods: {
    handleRemoveFile(fileList, index, key) {
      this.question.DeptData[index].childList[key].urlList = fileList;
    },
    async handleUpload(file, index, key) {
      const fileType = [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx"];
      if (!fileType.includes(file.name.slice(file.name.lastIndexOf(".")))) {
        this.$Message.warning("文件类型不正确！");
        return false;
      }
      if (file.size > 10485760) {
        this.$Message.warning("文件大小不能超过10M！");
        return false;
      }
      try {
        const { data } = await this.$http.MaterialsUploadFile(file);
        console.log(
          {
            name: file.name,
            url: data.data
          },
          "file"
        );
        this.$nextTick(() => {
          this.question.DeptData[index].childList[key].urlList.push({
            name: file.name,
            url: data.data
          });
        });
      } catch (error) {
        return false;
      }
      console.log(this.question.DeptData[index].childList[key].urlList, "urllist");
      return false;
    },
    async handleDel() {
      try {
        console.log(this.taskInfo.id, "BMWJ");
        await this.$http.batchDeleteInfo(this.taskInfo.id, "BMWJ");
        this.$emit("delModel");
        this.$Message.success("删除成功！");
      } catch (error) {
        console.log(error);
      }
    },
    handleAddParent() {
      if (this.question.DeptData.length === 50) {
        this.$Message.error("不能超过50条！");
        return;
      }
      this.question.DeptData.push({
        deptId: "",
        key: Math.floor(Math.random() * 1000000).toString(),
        childList: [
          {
            key: Math.floor(Math.random() * 1000000).toString(),
            title: "",
            descr: "",
            bizCode: "BMWJ",
            urlList: []
          }
        ]
      });
    },
    handleAddChild(index) {
      if (this.question.DeptData[index].childList.length === 50) {
        this.$Message.error("不能超过50条！");
        return;
      }
      this.question.DeptData[index].childList.push({
        key: Math.floor(Math.random() * 1000000).toString(),
        title: "",
        descr: "",
        bizCode: "BMWJ",
        urlList: []
      });
    },
    handleDelChild(parIndex, index) {
      this.question.DeptData[parIndex].childList = this.question.DeptData[
        parIndex
      ].childList.filter((val, i) => i !== index);
    },
    handleDelParent(index) {
      this.question.DeptData = this.question.DeptData.filter((val, i) => i !== index);
    },
    async getDept() {
      const { data } = await this.$http.listCaseDepartmentStepByChid({
        chId: sessionStorage.getItem("chId")
      });
      this.deptData = data.data;
    },
    // 删除
    delModel() {
      this.$emit("delModel");
    }
  },
  watch: {
    question: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.data)) {
          this.$emit("data1:data", val);
        }
      },
      deep: true,
      immediate: false // 初始时触发
    },
    data: {
      handler(val) {
        if (JSON.stringify(val) !== "{}") this.question = val; // 更新本地变量
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.getDept();
    this.$nextTick(() => {
      if (Object.keys(this.data).length !== 0) {
        if (Array.isArray(this.data)) {
          this.question.DeptData = this.data;
        } else {
          this.question = this.data;
        }
      }
      //   this.$emit("data1:data", this.question);
    });
  }
};
</script>

<style lang="stylus">
.ivu-input-default
  margin 0!important
</style>
<style lang="less" scoped>
.uploadDesc {
  font-size: 12px;
  font-family: MicrosoftYaHeiUI;
  color: rgba(128, 128, 128, 0.5);
}
</style>
